import React, {Fragment, useContext} from "react";
import {ApiUtility} from "../common/ApiUtility";
import {Constants} from "../common/Constants";
import {useModelCreateEngine} from "../common/hooks/useModelCreateEngine";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {ActivityMaterialForm} from "./ActivityMaterialForm";
import {GlobalContext} from "../admin-frame/AdminFrame";

export let CreateActivityMaterialPage = function () {
    const context = useContext(GlobalContext);
    const materialsListPath = `/${Constants.routes.settings.pathSegment}/activity-materials`;
    const modelCreateEngine = useModelCreateEngine(
        ApiUtility.createActivityMaterial,
        'material',
        () => context.navigator.navigateTo(materialsListPath)
    );

    return (
        <Fragment>
            <ConditionalRenderer if={modelCreateEngine.dataStore.data().loading} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <ActivityMaterialForm
                save={modelCreateEngine.createModel}
                isNew={true}
            />
        </Fragment>
    );
};
